module.exports = __webpack_public_path__ + "static/ziraat-3-102a1993d05a14238b2c8d17078bed7e.png";